import React from 'react'

const hundredBooks = {
    id:  '100-books',
    type: 'post',
    countryId: 'mAndI',
    title: 'How I\'m Going to Read 100 Books This Year',
    longDate: 'March 24, 2019',
    month: 'Mar',
    date: '24',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/100-books/bookscover.jpg',
    content: [
        {
            text: (
                <div>One of the huge benefits of taking time out from a full-time job to travel is that we've gained space in our lives for more hobbies. Peter has gotten even more interested in chess, and works to improve his game in addition to the time he spends working on <a href="https://itunes.apple.com/us/app/chess-tactics-and-lessons/id531275673?mt=8">his app</a>. And I've been learning photography and a bit of digital design, as well as reading a ton. (Yes, I also have more time for Instagram... let's forget about that hobby for now, though.)</div>
            )
        },
        {
            text: (
                <div><a href="http://www.goodreads.com/">Goodreads</a> has a Reading Challenge feature, where you publicly set a goal and track your progress towards it. Since I read exclusively on Kindle now and it's connected to my account, it automatically updates what I've read. I set 50 books as a goal for 2018 and ended up at 62.</div>
            )
        },
        {
            text: (
                <div>When we're in places without great wifi, reading is easy – chatting and cards are my only other options! But when we had our homebase in <a href="https://worldofwander.app/post/saigon">Saigon</a> and were traveling around Southeast Asia, where good WiFi is the norm, it became more challenging. I found myself spending evenings glued to my screen, which left me feeling bored and unproductive.</div>
            )
        },
        {
            text: (
                <div>So, I decided to set a scarily ambitious goal for 2019: 100 books. That's two per week. When I posted this on my IG stories in January, one friend reached out to say she found it inspiring and asked how I practically went about doing it. She asked, "How do you A) read so fast and B) stick to reading when you aren't motivated?!" After chatting back and forth, she suggested I write a blog post. (Brie, thank you for the nudge and inspiration!)</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/100-books/LandscapeBooks.png',
            detailText:'The first 24 books I read in 2019.'
        },
        {
            header: 'How to Read a Ton of Books'
        },
        {
            subheader: '1. Be Kind to Yourself'
        },
        {
            text: (
                <div>First, don't beat yourself up if you turn to TV or the internet for an evening instead of a book. Guilt doesn't serve you, and you shouldn't feel shitty about yourself for looking for comfort!</div>
            )
        },
        {
            text: (
                <div>Reading should be a restorative and relaxing habit, so the key is to fit it into your life in a way that doesn't feel like a chore. I try to leave the last half hour of every evening for reading. This is especially useful if you're a full-time employee, short on sleep, and stressed about getting to bed on time. An hour before you want to go to sleep, shut down the devices, do your Korean skincare routine, then get into bed and read. You'll probably get sleepy pretty quickly and only end up reading for 15 minutes or so – at least that's what happens for me!</div>
            )
        },
        {
            subheader: '2. Read in Small Chunks'
        },
        {
            text: (
                <div>I had a friend in high school who carried a book around with her everywhere she went. Whenever she had 5 minutes, she would get it out and read just a bit. She read more books than anyone I knew and it was astonishing how many she got through just by reading small bits at a time.</div>
            )
        },
        {
            text: (
                <div>When I worked full-time in San Francisco, that's the strategy I took, which got me partway to 50 books per year. I used to read on the MUNI subway for 15 minutes each direction in the mornings. I hope they never get internet down there – it was a great small part of the day to unplug. Instead of checking social media next time you have a moment, try pulling out your book or Kindle.</div>
            )
        },
        {
            subheader: '3. Don\'t Buy a Bunch of Books at Once'
        },
        {
            text: (
                <div>Motivation is a huge stumbling block for people who want to read more, but just can't seem to get themselves to do it. If this is you, it's probably because you don't actually want to read whatever book you "scheduled" for yourself to read - and that's OK.</div>
            )
        },
        {
            text: (
                <div>I used to go to the bookstore and pick out 6 or 7 books that were either on the Man Booker / NY Times / etc. list or that I thought would be valuable to read. And most of the time, I read one of these right off the bat and the rest sat on my shelf taunting me for months or years. When I (mostly unsuccessfully) decluttered my hundreds of books in 2017, I was sad to find dozens of books in this category – Middlemarch, books on Russian history, challenging short story collections – which were all aspirational books. If you read Middlemarch, you must be intellectual, right?</div>
            )
        },
        {
            text: (
                <div>The thing is, reading is for fun! So if you look at something on your shelf and you don't feel motivated to pick it up even though you "should", then don't. Read something lighthearted instead! I always alternate a something heavy with a quick romp (recent examples are Jilly Cooper's Polo and Gabourey Sidibe's autobiography). If you want to read a lot, you have to get re-enchanted with stories and let yourself fall into them. That way, you'll view reading as a fully fun activity, and when you do want to try some Ta-Nehisi Coates, you'll be in the groove.</div>
            )
        },
        {
            text: (
                <div>Another tip: Buy one book at a time. Whatever you feel like reading in the moment when you're looking for a new book is what you should read. Plus, let's all cut down our clutter and unnecessary book-hoarding, alright? It took me a long time to let go of the idea that having "smart" books on my shelf would prove I was smart (to who, you might ask? Excellent question.) Does this also describe you?</div>
            )
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/mAndI/100-books/books1.jpg','https://plivesey.github.io/world-of-wander-images/posts/mAndI/100-books/books2.jpg'],
            detailText:'In June 2017 I attempted to declutter my hundreds of books. In May 2018, in the weeks before we left to travel the world, I tried again and actually succeeded – letting go of the idea that I needed physical books to prove I was a good reader. I think I have about 20 in storage now – only my favorites and ones I actually revisit.'
        },
        {
            subheader: '4. Stop Reading It If You Aren\'t Enjoying It'
        },
        {
            text: (
                <div>This goes hand-in-hand with number three. If you're dragging your feet every time it's "reading time" because you're not into your book, stop reading it. I used to think I needed to finish every book I started. It was a point of pride for an audience of one. This is stupid. Reading is a treat – don't force it down like that apple cider vinegar shot that some blog said was good for you.</div>
            )
        },
        {
            subheader: '5. Learn from Your Non-Fiction'
        },
        {
            text: (
                <div>This strategy actually slows down your reading a bit, but makes it far more useful to your life. I've read far too many non-fiction books and been asked a few weeks later what the main points of the book were, only to completely draw a blank.</div>
            )
        },
        {
            text: (
                <div>Now, I use <a href="https://gretchenrubin.com/2018/02/faq-process-for-taking-notes/">Gretchen Rubin's method</a> to engage more thoroughly with books and actually remember what I read. Basically, highlight and take notes. Then, go back through and write them down. It's simple and yet felt revolutionary when I started doing it. I no longer feel like reading non-fiction is an ultimately useless pursuit – it feels worthwhile because I'm learning.</div>
            )
        },
        {
            text: (
                <div>I keep a folder in my Google Drive called Reading Notes, and have a document for each major theme. Whenever I read an article or book related to that theme (say, habit formation, psychology, or happiness), I dump in my notes and quotes. It's even better if I go through and write them down by hand first – yes, with a non-electronic implement! – because that's just how my brain learns best. The process of reviewing the thesis and main points along with supporting passages really helps cement it in there.</div>
            )
        },
        {
            Header: 'Find me on <a href="https://www.goodreads.com/alice_avery_6763">Goodreads</a>!'
        },
        {
            text: (
                <div>It's a cool site for organizing your virtual library and connecting with people. I'd love to see what you're reading, so <a href="https://www.goodreads.com/alice_avery_6763">add me as a friend</a>!</div>
            )
        },
]
}


export default hundredBooks


// WEBPACK FOOTER //
// ./src/Posts/Content/100Books.js